import type { ICampaignMetricMinimal } from "../../../../types/models/campaign-metric.types";
import { usePostHttp } from "../../http.hook";

interface IResponse {
  metrics: ICampaignMetricMinimal;
}

export function useGetGlobalMetricsAdminHttp() {
  return usePostHttp<null, IResponse>({
    path: "/admin/campaigns/metrics",
  });
}
